import { requestHelpers } from '../../../../../helpers';
import { updateTodoList } from '../../../../../actions/todo_list/todo_list';

export const actions = {
    SET_PROFILE_EXPERTISE: "SET_PROFILE_EXPERTISE",
    GENERAL_EXPERTISE_REQUEST: "GENERAL_EXPERTISE_REQUEST",
    GENERAL_EXPERTISE_SUCCESS: "GENERAL_EXPERTISE_SUCCESS",
    GENERAL_EXPERTISE_ERROR: "GENERAL_EXPERTISE_ERROR",
    CREATE_EXPERTISE: "CREATE_EXPERTISE",
    CLEAR_EXPERTISE_REDUCER: "CLEAR_EXPERTISE_REDUCER",
    SET_EXPERTISE_REQUEST: "SET_EXPERTISE_REQUEST",
};

export const setExpertise = ( profile ) => {
    return {
        type: actions.SET_PROFILE_EXPERTISE,
        personId: profile.id,
        expertise: profile.expertise,
    }
};

export const createExpertise = (personId, expertise, dataWithNames) => {
    // using the CRM endpoint as it is working - instead of
    // profiles/person_id/expertise
    return (dispatch) => {
        dispatch(setExpertiseRequest())
        requestHelpers
            .authenticatedPostRequest(`/sales/survey/${personId}`, expertise, "PUT")
            .then(() => {
                dataWithNames.updatedProfile = true;
                return dispatch({
                    type: actions.CREATE_EXPERTISE,
                    dataWithNames,
                    request: false
                })
            })
            .catch((error) => {
                console.log('ERROR:', error)
            });
      dispatch(updateTodoList(personId, 7));
    }
}

export const clearExpertiseReducer = () => {
    return (dispatch) => {
        dispatch({
            type: actions.CLEAR_EXPERTISE_REDUCER,
            dataWithNames: null,
        })
    }
}

export const setExpertiseRequest = () => {
    return (dispatch) => {
        dispatch({
            type: actions.SET_EXPERTISE_REQUEST,
            request: true
        })
    }
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/expertise.js